module.exports = __webpack_public_path__ + "img/Dedication_Nov_28_1981.148ff839.jpg";